import * as React from 'react';
import { createContextValueGetter } from '../../utils/helper';
export var SelectOptionContext = React.createContext({
    parentMenuId: '',
    isMultiple: false,
});
export var getOptionHtmlId = function (menuId, optionValue) { return menuId + "-" + optionValue; };
export var getSelectOptionContext = createContextValueGetter();
